import { useState } from 'react';

const faqs = [
  {
    q: 'Czym jest Kakobuy Spreadsheet?',
    a: 'Kakobuy Spreadsheet to kompleksowy arkusz z listą produktów, który pomaga użytkownikom szybko znaleźć, porównać i wybrać najlepsze produkty dostępne na platformie Kakobuy. Zawiera kategorie, ceny, linki oraz zdjęcia QC.',
  },
  {
    q: 'Czy Kakobuy Spreadsheet jest darmowy?',
    a: 'Tak, Kakobuy Spreadsheet jest całkowicie darmowy dla wszystkich użytkowników. Naszym celem jest ułatwienie dostępu do najlepszych produktów i oszczędność Twojego czasu podczas zakupów.',
  },
  {
    q: 'Jak znaleźć najlepsze produkty w Kakobuy Spreadsheet?',
    a: 'Wystarczy wybrać interesującą Cię kategorię, przeglądać listę produktów i porównywać je pod kątem ceny, jakości oraz opinii. Każdy produkt posiada bezpośredni link do strony zakupu.',
  },
  {
    q: 'Czy Kakobuy jest bezpieczny?',
    a: 'Kakobuy to platforma pośrednicząca, która łączy kupujących ze sprzedawcami. Korzystając z Kakobuy Spreadsheet, zawsze sprawdzaj opinie sprzedawców, analizuj zdjęcia QC i porównuj opcje wysyłki przed dokonaniem zakupu.',
  },
  {
    q: 'Jak korzystać ze zdjęć QC w Kakobuy Spreadsheet?',
    a: 'Zdjęcia QC (Quality Control) to fotografie rzeczywistych produktów wykonane przez agentów. W arkuszu znajdziesz linki do tych zdjęć — zawsze sprawdzaj je przed zakupem, aby ocenić rzeczywistą jakość produktu.',
  },
  {
    q: 'Jak często aktualizowany jest Kakobuy Spreadsheet?',
    a: 'Kakobuy Spreadsheet jest regularnie aktualizowany, aby zapewnić dostęp do najnowszych produktów i najlepszych okazji. Sprawdzaj stronę regularnie, aby nie przegapić nowych finds.',
  },
  {
    q: 'Czy Kakobuy Spreadsheet działa na urządzeniach mobilnych?',
    a: 'Tak, Kakobuy Spreadsheet jest w pełni responsywny i działa na wszystkich urządzeniach — komputerach, tabletach i smartfonach, dzięki czemu możesz przeglądać produkty gdziekolwiek jesteś.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.a,
      },
    })),
  };

  return (
    <section className="relative w-full py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 text-center mb-4">
          (Najczęściej Zadawane Pytania)
        </h2>
        <p className="font-body text-base text-foreground-600 text-center mb-12">
          Wszystko co musisz wiedzieć o Kakobuy Spreadsheet
        </p>

        <div className="flex items-center gap-2 mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-foreground-950 text-background-50 font-label text-xs font-semibold rounded-full">
            <i className="ri-star-fill text-secondary-400 text-xs"></i>
            Top 7 FAQ
          </span>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-2xl border border-background-200/60 overflow-hidden transition-all duration-300"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-label text-sm font-semibold text-foreground-950 pr-4">{faq.q}</span>
                <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openIndex === i ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-500'}`}>
                  <i className={`text-sm transition-transform duration-300 ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="font-body text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center gap-4 justify-center">
          <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20smiling%20young%20ecommerce%20expert%2C%20clean%20white%20background%2C%20friendly%20approachable%20look%2C%20soft%20natural%20lighting%2C%20modern%20professional%20style&width=100&height=100&seq=faq-avatar-01&orientation=squarish"
              alt="Ekspert Kakobuy"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div>
            <p className="font-label text-sm font-semibold text-foreground-950">Ekspert Kakobuy</p>
            <p className="font-body text-xs text-foreground-500">kakobuyfinds.fun</p>
          </div>
        </div>
      </div>
    </section>
  );
}